export default __webpack_public_path__ + "static/media/Beard_7_C3.f6667134.svg";